import React from "react";
import PrettyRating from "pretty-rating-react";
import Rating from "@mui/material/Rating";
import { IoLocation } from "react-icons/io5";
import { MdLocalPhone } from "react-icons/md";

const Card = ({ place, selected, refProp, width}) => {
  if (selected && width != 's') {
    refProp?.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    // refProp?.current?.scrollTop()
  }
  return (
    <>
      {place && (
        <div className="w-10/12 bg-[#f6f7fc] shadow-xl mx-auto mt-[20px] text-lg">
          <div className="w-full">
            <img
              className="object-cover w-full h-full"
              alt={place.name}
              src={
                place.photo
                  ? place.photo.images.large.url
                  : "https://th.bing.com/th/id/OIP.Dh7pFto7YSJM6dRwII-EGQHaE8?w=245&h=180&c=7&r=0&o=5&pid=1.7"
              }
            />
          </div>
          <div className="w-11/12 mx-auto">
            <h1 className="text-2xl font-bold py-2">{place.name}</h1>
            <div className="flex flex-row flex-wrap w-full justify-between py-1">
              <div className="flex flex-row justify-between">
                <Rating
                  name="read-only"
                  value={Number(place.rating)}
                  readOnly
                />
              </div>
              <div>
                <p>{place.num_reviews} reviews </p>
              </div>
            </div>
            <div className="flex flex-row flex-wrap w-full justify-between content-center">
              <div className="flex w-1/4 flex-row justify-between">
                <p>Price</p>
              </div>
              <div>
                <p>{place.price_level ? place.price_level : "$"}</p>
              </div>
            </div>
            <div className="flex flex-row flex-wrap w-full justify-between content-center">
              <div className="flex w-1/4 flex-row justify-between">
                <p>Ranking</p>
              </div>
              <div>
                <p>
                  {place.ranking ? (
                    toString(place.ranking).length > 14 ? (
                      place.ranking.slice(0, 20)
                    ) : (
                      place.ranking
                    )
                  ) : (
                    <p>no ranking</p>
                  )}
                </p>
              </div>
            </div>
            <div className="">
              {place.awards && (
                <>
                  {place.awards.map((award, i) => {
                    return (
                      <div
                        className="flex flex-row flex-wrap justify-between content-center mt-1"
                        key={i}
                      >
                        <img src={award.images.small} alt="test" />
                        <p>{`Certification of Excellence ${award.year}`}</p>
                      </div>
                    );
                  })}
                </>
              )}
            </div>
            <div className="flex flex-row flex-wrap my-2">
              {place?.cuisine?.map((cui) => {
                return (
                  <div className="px-2 m-1 bg-[#39dff3] text-[#f6f7fc] rounded-xl">
                    {cui.name ? cui.name : <></>}
                  </div>
                );
              })}
            </div>
            <div>
              <div className="flex flex-row justify-start align-middle content-center ">
                <IoLocation />
                <p className="-mt-1 ml-2">
                  {place?.address ? place.address : <></>}
                </p>
              </div>
              <div className="flex flex-row justify-start align-middle content-center ">
                <MdLocalPhone />
                <p className="-mt-1 ml-2">
                  {place?.phone ? place.phone : <></>}
                </p>
              </div>
            </div>
            <div>
              <button
                type="button"
                className="text-md py-1 px-2 bg-gradient-to-t from-[#39dff3] to-[#f677c0] m-2 text-[#f6f7fc] font-light  hover:rounded-lg hover:bg-gradient-to-b"
                onClick={() => window.open(`${place.write_review}`, "_black")}
              >
                TRIP ADVISOR
              </button>
              <button
                type="button"
                className="text-md py-1 px-2 bg-gradient-to-t from-[#39dff3] to-[#f677c0] m-2 text-[#f6f7fc] font-light  hover:rounded-lg hover:bg-gradient-to-b"
                onClick={() => window.open(`${place.web_url}`, "_black")}
              >
                WEBSITE
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Card;
